import { Box, Container, Grid, Typography } from "@mui/material";


const features = [
  {
  num: "01",
  title: "Faster Inventory Movement",
  desc: "Accelerate deal cycles without compromising positioning",
},
{
  num: "02",
  title: "Stronger Deal Quality",
  desc: "Focus on high-intent buyers, not volume-driven closures",
},
{
  num: "03",
  title: "Pricing Without Discounting",
  desc: "Close premium deals while protecting price integrity",
},
{
  num: "04",
  title: "Complete Sales Visibility",
  desc: "Full clarity across pipeline, conversations, and conversions",
}
  // {
  //   num: "05",
  //   title: "Strategic Deal Support",
  //   desc: "Involvement in high-value conversations",
  // },
  // {
  //   num: "06",
  //   title: "Market Understanding",
  //   desc: "Deep expertise in luxury real estate dynamics",
  // },
];

const WhyDevelopers = () => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/hitec-city.webp")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        py: 10,
        backgroundAttachment: "fixed",
        overflow: "hidden",
      }}
    >
      {/* 🔵 LUXURY BLUE OVERLAY */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: `
            linear-gradient(
              135deg,
              rgba(15,99,165,0.85),
              rgba(15,99,165,0.6)
            )
          `,
        }}
      />

      {/* ✨ GLOSS LIGHT */}
      <Box
        sx={{
          position: "absolute",
          top: "-20%",
          left: "-10%",
          width: "600px",
          height: "600px",
          background:
            "radial-gradient(circle, rgba(255,255,255,0.25), transparent 70%)",
          filter: "blur(80px)",
        }}
      />

      <Container sx={{ position: "relative", zIndex: 2 }}>
        
        {/* HEADER */}
        <Box sx={{ textAlign: "center", mb: 10 }}>
          <Box
            sx={{
              width: 70,
              height: 3,
              margin: "0 auto 12px",
              background: "rgba(255,255,255,0.8)",
              borderRadius: "10px",
            }}
          />

          <Typography
          variant="h4"
            sx={{
              
              fontSize: { xs: 34, md: 48 },
              color: "#ffffff",
              fontWeight: 600,
            }}
          >
            Why Developers Choose RW Realty
          </Typography>
        </Box>

        {/* GRID */}
        <Grid container spacing={4}>

          {features.map((item, index) => (
            <Grid item xs={12} md={6} key={index}>

              <Box
                sx={{
                  display: "flex",
                  gap: 3,
                  p: 4,
                  borderRadius: "22px",
                  position: "relative",
                  overflow: "hidden",
                  textAlign:'start',

                  // 💎 GLASS CARD
                  background: `
                    linear-gradient(
                      145deg,
                      rgba(31, 125, 187, 0.65),
                      rgba(18, 112, 201, 0.65)
                    )
                  `,
                  // background: `
                  //   linear-gradient(
                  //     145deg,
                  //     rgba(255,255,255,0.15),
                  //     rgba(255,255,255,0.05)
                  //   )
                  // `,
                  // background: `
                  //   linear-gradient(145deg, rgb(5 34 59 / 90%), rgb(9 83 127 / 17%)
                  // `,
                  
                  backdropFilter: "blur(12px)",

                  // 💎 BORDER
                  border: "1px solid rgba(255,255,255,0.25)",

                  // 💎 SHADOW DEPTH
                  boxShadow: `
                    0 10px 30px rgba(0,0,0,0.25),
                    0 25px 60px rgba(0,0,0,0.35)
                  `,

                  transition: "all 0.4s ease",

                  "&:hover": {
                    transform: "translateY(-8px) scale(1.02)",
                    boxShadow: `
                      0 20px 50px rgba(0,0,0,0.35),
                      0 40px 80px rgba(0,0,0,0.4)
                    `,
                  },

                  // 🔥 GLOSS REFLECTION
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "-40%",
                    left: "-20%",
                    width: "160%",
                    height: "160%",
                    background:
                      "radial-gradient(circle, rgba(255,255,255,0.2), transparent 60%)",
                    transform: "rotate(25deg)",
                  },
                }}
              >

                {/* NUMBER */}
                <Box
                  sx={{
                    minWidth: 50,
                    height: 50,
                    borderRadius: "14px",
                    background: "rgba(255,255,255,0.2)",
                    backdropFilter: "blur(10px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#ffffff",
                    fontWeight: 600,
                    fontSize: 14,
                    boxShadow: "0 0 10px rgba(255,255,255,0.3)",
                    fontFamily: "Playfair Display, serif",
                  }}
                >
                  {item.num}
                </Box>

                {/* TEXT */}
                <Box>
                  <Typography
                  variant="body1"
                    sx={{
                      
                      fontSize: 14,
                      color: "#fff",
                      mb: 1,
                      fontFamily: '"Playfair Display", serif !important',
                    }}
                  >
                    <b>{item.title}</b>
                  </Typography>

                  <Typography
                  variant="body2"
                    sx={{
                      color: "rgba(255,255,255,0.85)",
                      fontSize: 14,
                      lineHeight: 1.7,
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>

                {/* EDGE LIGHT */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    borderRadius: "22px",
                    border: "1px solid rgba(255,255,255,0.3)",
                  }}
                />

              </Box>

            </Grid>
          ))}

        </Grid>
      </Container>
    </Box>
  );
};

export default WhyDevelopers;